import availableTours from '../getAvailableTours.api';
import {Group, GroupEditingLevelTypes} from '../../../../graphql/groups.datatypes';
import LockOpenIcon from '@material-ui/icons/LockOpenOutlined';
import LockClosedIcon from '@material-ui/icons/LockOutlined';
import {makeStyles} from '@material-ui/styles';
import moment from 'moment';
import {useSnackbar} from 'notistack';
import React, {EventHandler, useEffect, useMemo, useState} from 'react';
import {NavLink} from 'react-router-dom';
import useRouter from 'use-react-router';
import validate from 'validate.js';
import {Can} from '../../../../components/Can';
import {checkPermission} from '../../../../components/Can/Can';
import {
    Button,
    Card,
    CardContent,
    CardHeader,
    colors,
    Divider,
    Grid,
    IconButton,
    InputAdornment,
    Link as MuiLink,
    Switch,
    Tab,
    Tabs,
    TextField,
    Theme,
    Typography
} from '@material-ui/core';
import {getHandleFieldChange, getHasError} from '../../../../utils/formHelpers';
import {OverdueDocumentListLoad} from '../../../Documents/OverdueDocumentsList/OverdueDocumentList';
import {LogListContent} from '../../../Logs/LogList/LogList';
import {GroupOptions} from '../../GroupOptions';
import {GroupAdminListContent} from '../../GroupAdminList/GroupAdminList';
import {GroupMemberListContent} from '../../GroupMemberList/GroupMemberList';
import cloneGroup from '../cloneGroup.api';
import createGroup, {CreateGroupInput} from '../createGroup.api';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import updateGroup, {UpdateGroupInput} from '../updateGroup.api';
import MediumEditorField from '../../../../components/MediumEditor/MediumEditorField';
import {getHost} from '../../../../graphql/GraphQlProvider';
import GroupOverview from '../../GroupOverview/GroupOverview';
import AvailableHotelModal from '../../../Resources/AvailableHotelModal';
import {Resource} from '../../../../graphql/resources.datatypes';
import AvailableToursModal from '../../../Resources/AvailableTourModal';
import {WcvType} from '../../../../graphql/logs.datatypes';
import AddNote from '../../../Logs/AddNote/AddNote';
import {RoomPartyListContent} from '../../../RoomParty/RoomPartyList/RoomPartyList';
import {BillingPartyListContent} from '../../../BillingParty/BillingPartyList/BillingPartyList';
import MergeRoomPartyModal from '../../../RoomParty/MergeRoomPartyModal';
import {DocumentListContent} from '../../../Documents/DocumentsList/DocumentsList';
import {
    DocumentDetailsContent,
    getBlankDocument
} from '../../../Documents/DocumentDetails/DocumentDetails';
import {getMe} from '../../../../graphql/auth';
import {WCVDatePicker} from '../../../../components/DateUtilsProvider/WCVDatePicker';
import {formatGraphQlDate} from '../../../../utils/formatters';
import limitedUpdateGroup from '../limitedUpdateGroup.api';
import {T} from 'react-polyglot-hooks';
import {getBlankGroup} from '../GroupDetails';
import getGroupWithQuery from '../../getGroupWithQuery.api';
import {
    GroupMembersPendingApprovalListContent
} from '../../GroupMembersPendingApprovalList/GroupMembersPendingApprovalList';
import {
    gqlGroupForAdminsTabQuery,
    gqlGroupForBillingPartiesTabQuery,
    gqlGroupForDetailsTabQuery,
    gqlGroupForMembersTabQuery,
    gqlGroupForRoomPartiesTabQuery,
    gqlGroupOptionsQuery
} from '../../getGroupQueries.api';
import NewBillingPartyModal from "../NewBillingPartyModal/NewBillingPartyModal";
import {NotesList} from '../../../Notes';


const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    container: {
        marginTop: theme.spacing(3),
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    card: {},
    saveButton: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        }
    },
    deleteButton: {
        marginLeft: theme.spacing(1),
        color: theme.palette.white,
        backgroundColor: theme.palette.error.light,
        '&:hover': {
            backgroundColor: theme.palette.error.main
        }
    },
    cloneButton: {
        marginLeft: theme.spacing(1),
        color: theme.palette.white,
        backgroundColor: colors.green[400],
        '&:hover': {
            backgroundColor: colors.green[700]
        }
    },
    errorIcon: {
        marginRight: theme.spacing(1),
        color: theme.palette.error.main,
    },
    marginBottom: {
        paddingLeft: theme.spacing(1),
        marginBottom: theme.spacing(3),
    },
    tabs: {
        marginTop: theme.spacing(3)
    },
    linkButton: {
        marginRight: theme.spacing(1),
        [theme.breakpoints.down('md')]: {
            marginBottom: 10,
        }
    },
    buttonWrapper: {
        [theme.breakpoints.down('md')]: {

            flexWrap: 'wrap',
            marginBottom: 10,
        },
    },
    buttonHeader: {
        [theme.breakpoints.down('md')]: {
            flex: 'auto',
            marginTop: 10,
            marginRight: 0,
            flexWrap: 'wrap',
        }
    }
}));

export const GroupDetailsOverviewTab = (props: {
    group: Group,
    isAdmin: boolean,
    canEdit: boolean
}) => {
    const {isAdmin, group, canEdit} = props;
    const [openModal, setOpenModal] = useState(false);
    const showPrices = isAdmin || (moment(group.end_date).add(15, 'days').diff(moment(), 'days') > 0);

    return (
        <React.Fragment>
            <GroupOverview group={group} showPrices={showPrices} isAdmin={isAdmin}/>

            {isAdmin && (
                <div>
                    <Button
                        color="primary"
                        onClick={() => setOpenModal(true)}
                        size="small"
                        variant="outlined"
                    >
                        Add Note
                    </Button>
                    <NotesList type={'group'} type_id={group.id}/>
                    {/* <LogListContent type={WcvType.GROUP} type_id={group.id} notes={true}/> */}
                    {openModal && (<AddNote onClose={() => setOpenModal(false)} type={WcvType.GROUP}
                                            type_id={group.id}/>)}
                </div>
            )}
        </React.Fragment>
    )
}

export const GroupDetailsDetailTab = (props: {
    group: Group,
    isAdmin: boolean,
    canEdit: boolean
}) => {
    const classes = useStyles();
    const {isAdmin, group, canEdit} = props;
    const isNewGroup = group.id === -1;
    const {history} = useRouter();
    const [open, setOpen] = React.useState(false);
    const [showCreditCardFee, setShowCreditCardFee] = useState(group && group.credit_card_fee && group.credit_card_fee > 0)
    const {enqueueSnackbar} = useSnackbar();
    const canFullUpdate = checkPermission('groups.update');
    const canLock = checkPermission('groups.lock');
    const [sendCreateGroup, createData] = createGroup();
    const [sendFullUpdateGroup, updateData] = updateGroup();
    const [sendLimitedUpdateGroup, limitedUpdateData] = limitedUpdateGroup();
    const sendUpdateGroup: any = canFullUpdate ? sendFullUpdateGroup : sendLimitedUpdateGroup;
    const [sendCloneGroup, cloneData] = cloneGroup();
    const showPrices = isAdmin || (moment(group.end_date).add(15, 'days').diff(moment(), 'days') > 0);

    //1. Set form and error state
    const [formState, setFormState] = useState({...group});

    //tours
    const toursData = availableTours();
    const [errors, setErrors] = useState({
        isValid: false,
        errors: {
            name: false,
            description: false,
            start_date: false,
            end_date: false,
            admissions_cutoff: false,
        }
    });

    const selectedTour = formState && (toursData.data && toursData.data.availableTours) ? toursData.data.availableTours.find(tour => Number(tour.id) === formState.tour_resource_id) : null;
    const ratio = group.comp_ratio ? group.comp_ratio + 1 : 1;
    const compDollarEstimate = group.members && Math.floor(group.members!.length / ratio) * group.comp_dollar_value!;

    //2. Setup helper functions for form
    const handleFieldChange = getHandleFieldChange(setFormState);
    const hasError = getHasError(errors);

    //3. setup validation and error hook
    const validateSchema = useMemo(() => {
    const schema: any = {
        name: {
            presence: {allowEmpty: false, message: 'is required'},
        },
        description: {
            presence: {allowEmpty: false, message: 'is required'},
        },
        start_date: {
            presence: {allowEmpty: false, message: 'is required'},
        },
        end_date: {
            presence: {allowEmpty: false, message: 'is required'},
        },
        admissions_cutoff: {
            presence: {allowEmpty: false, message: 'is required'},
            datetime: {
                latest: formState.start_date ? moment.utc(formState.start_date) : undefined,
                message: '^Admission cutoff must be before the group start date' + (formState.start_date ? ', ' + formState.start_date : '')
            },
        },
        hotel: {
            presence: {allowEmpty: false, message: 'is required'},
        },
        tour: {
            presence: {allowEmpty: false, message: 'is required'},
        },
        description_resort: {
            presence: {allowEmpty: false, message: 'is required'},
        },
        description_whats_included: {
            presence: {allowEmpty: false, message: 'is required'},
        },
        description_checkin: {
            presence: {allowEmpty: false, message: 'is required'},
        },
    };

    if (selectedTour) {
        const calculatedStartDate = moment.utc(selectedTour.available_from).subtract(selectedTour.max_nights_before, 'days');
        const calculatedEndDate = moment.utc(selectedTour.available_to).add(selectedTour.max_nights_after, 'days');

        schema.start_date.datetime = {
            earliest: calculatedStartDate,
            message: `^Start date must be on or after the tour additional night's start date, ${calculatedStartDate.format('YYYY-MM-DD')}`
        };
        schema.end_date.datetime = {
            latest: calculatedEndDate,
            message: `^End date must be on or before the tour additional night's end date, ${calculatedEndDate.format('YYYY-MM-DD')}`
        };
    }

    return schema;
}, [formState.start_date, selectedTour]);

    useEffect(() => {
        const newErrors = validate(formState, validateSchema);

        setErrors(state => ({
            ...state,
            isValid: !newErrors,
            errors: newErrors || {}
        }));
    }, [formState, validateSchema]);

    // Separate useEffect for credit card fee initialization (runs only once)
    useEffect(() => {
        const groupHasFee = group.credit_card_fee !== 0
        const groupFee = group.credit_card_fee;
        if (groupHasFee) {
            setShowCreditCardFee(groupHasFee);
            setFormState(prev => ({...prev, credit_card_fee: groupFee}))
        }
    }, []);


    //4. Handle save form
    const onSaveClick = () => {
        if (isNewGroup) {
            const sanitisedData: CreateGroupInput = {
                data: {
                    ...{
                        ...formState,
                        id: undefined,
                        __typename: undefined,
                        tour: undefined,
                        hotel: undefined,
                        members: undefined,
                        comp_dollar_estimate: undefined,
                        hasPrimaryLeader: undefined,
                        hasLeader: undefined,
                        optionIds: undefined,
                        options: undefined,
                        cost: undefined,
                        outstandingBalance: undefined,
                        overduePayments: undefined,
                        bookings: undefined,
                        payment_schedule: undefined,
                        documents: undefined,
                        credit_card_fee: showCreditCardFee ? formState.credit_card_fee : 0,
                        start_date: formatGraphQlDate(formState.start_date),//formState.start_date ? moment(formState.start_date).format('YYYY-MM-DD') : undefined,
                        end_date: formatGraphQlDate(formState.end_date),//formState.end_date ? moment(formState.end_date).format('YYYY-MM-DD') : undefined,
                        admissions_cutoff: formatGraphQlDate(formState.admissions_cutoff),//formState.admissions_cutoff ? moment(formState.admissions_cutoff).format('YYYY-MM-DD') : undefined,
                        start_date_additional: formatGraphQlDate(formState.start_date_additional),//formState.start_date_additional ? moment(formState.start_date_additional).format('YYYY-MM-DD') : undefined,
                        end_date_additional: formatGraphQlDate(formState.end_date_additional),//formState.end_date_additional ? moment(formState.end_date_additional).format('YYYY-MM-DD') : undefined,
                        booking_tool_edit_cutoff: formatGraphQlDate(formState.booking_tool_edit_cutoff),
                    },
                }
            };

            sendCreateGroup({variables: sanitisedData})
                .then(() => {
                    enqueueSnackbar('Group Saved.', {variant: 'success'});
                    history.push('/groups');
                })
                .catch(() => {
                    enqueueSnackbar('Save Group Failed!', {variant: 'error'});
                });
        } else {
            const sanitisedData: UpdateGroupInput = {
                data: {
                    ...{
                        ...formState,
                        __typename: undefined,
                        tour: undefined,
                        hotel: undefined,
                        members: undefined,
                        comp_dollar_estimate: undefined,
                        hasPrimaryLeader: undefined,
                        hasLeader: undefined,
                        associatedUsers: undefined,
                        optionIds: undefined,
                        options: undefined,
                        cost: undefined,
                        outstandingBalance: undefined,
                        overduePayments: undefined,
                        bookings: undefined,
                        payment_schedule: undefined,
                        documents: undefined,
                        credit_card_fee: showCreditCardFee ? formState.credit_card_fee : 0,
                        start_date: formatGraphQlDate(formState.start_date),//formState.start_date ? moment(formState.start_date).format('YYYY-MM-DD') : undefined,
                        end_date: formatGraphQlDate(formState.end_date),//formState.end_date ? moment(formState.end_date).format('YYYY-MM-DD') : undefined,
                        admissions_cutoff: formatGraphQlDate(formState.admissions_cutoff),//formState.admissions_cutoff ? moment(formState.admissions_cutoff).format('YYYY-MM-DD') : undefined,
                        start_date_additional: formatGraphQlDate(formState.start_date_additional),//formState.start_date_additional ? moment(formState.start_date_additional).format('YYYY-MM-DD') : undefined,
                        end_date_additional: formatGraphQlDate(formState.end_date_additional),//formState.end_date_additional ? moment(formState.end_date_additional).format('YYYY-MM-DD') : undefined,
                        booking_tool_edit_cutoff: formatGraphQlDate(formState.booking_tool_edit_cutoff),
                    },
                }
            };

            sendUpdateGroup({variables: sanitisedData})
                .then(() => {
                    enqueueSnackbar('Group Updated.', {variant: 'success'});
                })
                .catch(() => {
                    enqueueSnackbar('Group Update Failed!', {variant: 'error'});
                });
        }
    };

    const handleLock = () => {
        if (canLock) {
            sendUpdateGroup({variables: {data: {id: formState.id, locked: !formState.locked}}})
                .then(() => {
                    setFormState({...formState, locked: !formState.locked})
                    enqueueSnackbar(formState.locked ? 'Group Locked' : 'Group Unlocked.', {variant: 'success'});
                })
                .catch(() => {
                    enqueueSnackbar('Group Update Failed!', {variant: 'error'});
                });
        } else {
            enqueueSnackbar('You do not have permission to lock this Group.', {variant: 'error'});
        }
    };

    const handleClickOpen = () => {
        setOpen(true);
    };


    const onCloneClick = () => {
        sendCloneGroup({variables: {id: group.id!}})
            .then((response) => {
                enqueueSnackbar('Group Cloned.', {variant: 'success'});
                const newGroup = response.data!.cloneGroup as Group;
                history.push('/groups');
            })
            .catch(() => {
                enqueueSnackbar('Group Clone Failed!', {variant: 'error'});
            });
    };

    //change hotel functions.
    const [openHotelPopup, setOpenHotelPopup] = useState(false);
    const handleOpenHotelPopup = () => {
        setOpenHotelPopup(true);
    };

    const handleCloseHotelPopup = () => {
        setOpenHotelPopup(false);
    };

    const handleConfirmHotelId = (hotel?: Resource) => {
        setFormState({
            ...formState,
            hotel_resource_id: !hotel ? undefined : hotel.id,
            hotel
        });
        handleCloseHotelPopup();
    };

    //change tour functions.
    const [openTourPopup, setOpenTourPopup] = useState(false);
    const handleOpenTourPopup = () => {
        setOpenTourPopup(true);
    };

    const handleCloseTourPopup = () => {
        setOpenTourPopup(false);
    };

    const handleConfirmTourId = (tour?: Resource) => {
        setFormState({
            ...formState,
            tour_resource_id: tour ? tour.id : undefined,
            tour,
            hotel_resource_id: -1,
            hotel: undefined,
            start_date: tour ? formatGraphQlDate(tour.available_from) : undefined,
            end_date: tour ? formatGraphQlDate(tour.available_to) : undefined,
            admissions_cutoff: tour ? formatGraphQlDate(tour.available_from) : undefined,
            booking_tool_edit_cutoff: tour ? formatGraphQlDate(tour.booking_tool_edit_cutoff) : undefined,
            start_date_additional: tour ? formatGraphQlDate(moment(tour.available_from).subtract(tour.max_nights_before ? tour.max_nights_before : 0, 'days')) : undefined,
            end_date_additional: tour ? formatGraphQlDate(moment(tour.available_to).add(tour.max_nights_after ? tour.max_nights_after : 0, 'days')) : undefined,
            max_additional_nights: tour ? tour.max_additional_nights : 0,
        });
        handleCloseTourPopup();
    };

    const handleCCFeeChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        event.target.value = Number(event.target.value) < 0 ? '0' : event.target.value;
        handleFieldChange(event);
    }


    return (
        <React.Fragment>
            <Card className={classes.container}>
                <CardHeader title="Group Details" action={isAdmin && !isNewGroup && (
                    <IconButton
                        color="inherit"
                        onClick={handleLock}
                    >
                        {formState.locked && (<LockClosedIcon/>)}
                        {!formState.locked && (<LockOpenIcon/>)}
                    </IconButton>
                )}/>
                <CardContent className={classes.card}>

                    <Grid container spacing={3}>

                        {!formState.hasPrimaryLeader && (
                            <Typography color="error" variant="h4" className={classes.marginBottom}>
                                <ErrorOutlineIcon className={classes.errorIcon}/>
                                No Primary Leader is set. This group is not valid until one has been
                                set.
                            </Typography>
                        )}
                        {!formState.hasLeader && (
                            <Typography color="error" variant="h4" className={classes.marginBottom}>
                                <ErrorOutlineIcon className={classes.errorIcon}/>
                                No Leaders are set. This group is not valid until one has been set.
                            </Typography>
                        )}

                        <Grid item xs={12}>
                            <TextField
                                {...hasError('name')}
                                fullWidth
                                label="Name"
                                name="name"
                                onChange={handleFieldChange}
                                value={formState.name}
                                variant="outlined"
                                disabled={formState.locked || !canEdit}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                {...hasError('description_resort')}
                                fullWidth
                                label="Hotel Name"
                                name="description_resort"
                                onChange={handleFieldChange}
                                value={formState.description_resort}
                                variant="outlined"
                                disabled={formState.locked || !isAdmin}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <MediumEditorField
                                {...hasError('description')}
                                fullWidth
                                label="Trip Description"
                                variant="outlined"
                                name="description"
                                multiline
                                value={formState.description}
                                onChange={(event: any) => setFormState({
                                    ...formState,
                                    description: event.target.value
                                })}
                                disabled={formState.locked || !isAdmin}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <MediumEditorField
                                {...hasError('description_whats_included')}
                                fullWidth
                                label="Description - What's Included"
                                variant="outlined"
                                name="description_whats_included"
                                multiline
                                value={formState.description_whats_included}
                                onChange={(event: any) => setFormState({
                                    ...formState,
                                    description_whats_included: event.target.value
                                })}
                                disabled={formState.locked || !isAdmin}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <MediumEditorField
                                {...hasError('description_insurance')}
                                fullWidth
                                label="Description - Insurance Info"
                                variant="outlined"
                                name="description_insurance"
                                multiline
                                value={formState.description_insurance}
                                onChange={(event: any) => setFormState({
                                    ...formState,
                                    description_insurance: event.target.value
                                })}
                                disabled={formState.locked || !isAdmin}
                            />
                        </Grid>

                        {isAdmin && (
                            <Grid item xs={12}>
                                <TextField
                                    {...hasError('description_checkin')}
                                    fullWidth
                                    label="Arrival/Departure Info"
                                    name="description_checkin"
                                    onChange={handleFieldChange}
                                    value={formState.description_checkin}
                                    variant="outlined"
                                    disabled={formState.locked || !isAdmin}
                                />
                            </Grid>
                        )}

                        {isAdmin && (
                            <Grid item xs={6}>
                                <TextField
                                    {...hasError('tour')}
                                    fullWidth
                                    label="Tour"
                                    value={formState.tour ? formState.tour!.internal_name : ''}
                                    variant="outlined"
                                    disabled={true}
                                />

                                {formState.tour_resource_id! === -1 && (
                                    <Button variant={'outlined'} onClick={handleOpenTourPopup}>Choose
                                        Tour</Button>
                                )}
                                {formState.tour_resource_id! !== -1 && (
                                    <Can permission={['groups.change_tour']}>
                                        <Button variant={'outlined'} onClick={handleOpenTourPopup}>Change
                                            Tour</Button>
                                    </Can>
                                )}

                                {openTourPopup && (
                                    <AvailableToursModal
                                        onClose={handleCloseTourPopup}
                                        onConfirmClick={handleConfirmTourId}
                                        open={openTourPopup}
                                        currentTourId={formState.tour_resource_id!}
                                    />
                                )}
                            </Grid>
                        )}

                        {isAdmin && (
                            <Grid item xs={6}>
                                <TextField
                                    {...hasError('hotel')}
                                    fullWidth
                                    label="Hotel"
                                    name="hotel"
                                    value={formState.hotel ? formState.hotel!.internal_name : ''}
                                    variant="outlined"
                                    disabled={true}
                                />

                                {formState.hotel_resource_id! === -1 && (
                                    <Button variant={'outlined'} onClick={handleOpenHotelPopup}>Choose
                                        Hotel</Button>
                                )}
                                {formState.hotel_resource_id! !== -1 && (
                                    <Can permission={['groups.change_hotel']}>
                                        <Button variant={'outlined'} onClick={handleOpenHotelPopup}>Change
                                            Hotel</Button>
                                    </Can>
                                )}

                                {openHotelPopup && (
                                    <AvailableHotelModal
                                        onClose={handleCloseHotelPopup}
                                        onConfirmClick={handleConfirmHotelId}
                                        open={openHotelPopup}
                                        startDate={moment(new Date(formState.start_date!))}
                                        endDate={moment(new Date(formState.end_date!))}
                                        tourResourceId={formState.tour_resource_id!}
                                        currentHotelId={formState.hotel_resource_id!}
                                        isRoomParty={false}
                                    />
                                )}
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            <Typography variant="body1">Booking Form: <NavLink
                                to={'/booking/' + formState.booking_form_url}>{getHost() + '/booking/' + formState.booking_form_url}</NavLink></Typography>
                        </Grid>

                        {isAdmin && (
                            <Grid item xs={12}>
                                <TextField
                                    {...hasError('invoice_document_id')}
                                    fullWidth
                                    label="Invoice Document"
                                    name="invoice_document_id"
                                    onChange={handleFieldChange}
                                    select
                                    // eslint-disable-next-line react/jsx-sort-props
                                    SelectProps={{native: true}}
                                    InputLabelProps={{shrink: true}}
                                    value={formState.invoice_document_id}
                                    variant="outlined"
                                    disabled={formState.locked || !canEdit}
                                >
                                    <option value={-1}>Use Tour Default</option>
                                    {group.documents && group.documents.map((document) => (
                                        <option key={'document_' + document.id} value={document.id}>
                                            {document.title}
                                        </option>
                                    ))}
                                </TextField>
                                <MuiLink target="_blank"
                                         href={getHost() + '/invoice_template/' + WcvType.GROUP + '/' + group.id}>
                                    <Button variant="contained"><T
                                        phrase="Download Template"/></Button>
                                </MuiLink>
                            </Grid>
                        )}

                        {isAdmin && (
                            <Grid item xs={12}>
                                <TextField
                                    {...hasError('editing_level')}
                                    fullWidth
                                    label="Editing Level"
                                    name="editing_level"
                                    onChange={handleFieldChange}
                                    select
                                    // eslint-disable-next-line react/jsx-sort-props
                                    SelectProps={{native: true}}
                                    value={formState.editing_level}
                                    variant="outlined"
                                    disabled={formState.locked || !canEdit}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                    {GroupEditingLevelTypes.map((type, i) => (
                                        <option key={type.name} value={i}>
                                            {type.name}
                                        </option>
                                    ))}
                                </TextField>
                            </Grid>
                        )}

                        {(
                            <Grid item xs={12}>
                                <Grid container spacing={3}>
                                    <Grid item md={3}>
                                        <WCVDatePicker
                                            {...hasError('start_date')}
                                            id="start_date"
                                            label="Start Date:"
                                            value={formState.start_date}
                                            onChange={(date, value) => {
                                                setFormState({
                                                    ...formState,
                                                    start_date: value ? value : undefined
                                                })
                                            }}
                                            disabled={formState.locked || !isAdmin}
                                        />
                                    </Grid>
                                    <Grid item md={3}>
                                        <WCVDatePicker
                                            {...hasError('end_date')}
                                            id="end_date"
                                            label="End Date:"
                                            value={formState.end_date}
                                            onChange={(date, value) => {
                                                setFormState({
                                                    ...formState,
                                                    end_date: value ? value : undefined
                                                })
                                            }}
                                            disabled={formState.locked || !isAdmin}
                                        />
                                    </Grid>
                                    <Grid item md={3}>
                                        <WCVDatePicker
                                            {...hasError('admissions_cutoff')}
                                            id="admissions_cutoff"
                                            label="Admissions Cutoff:"
                                            value={formState.admissions_cutoff}
                                            onChange={(date, value) => {
                                                setFormState({
                                                    ...formState,
                                                    admissions_cutoff: value ? value : undefined
                                                })
                                            }}
                                            disabled={formState.locked || !isAdmin}
                                        />
                                    </Grid>
                                    <Grid item md={3}>
                                        <WCVDatePicker
                                            {...hasError('booking_tool_edit_cutoff')}
                                            id="booking_tool_edit_cutoff"
                                            label="Booking Tool Edit Cutoff Date:"
                                            value={formState.booking_tool_edit_cutoff}
                                            onChange={(date, value) => {
                                                setFormState({
                                                    ...formState,
                                                    booking_tool_edit_cutoff: value ? value : undefined
                                                })
                                            }}
                                            disabled={formState.locked || !isAdmin}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}

                        {isAdmin && (
                            <Grid item xs={12}>
                                <Grid container spacing={3}>
                                    <Grid item md={4}>
                                        <WCVDatePicker
                                            {...hasError('start_date_additional')}
                                            id="start_date_additional"
                                            label="Additional Nights Start:"
                                            value={formState.start_date_additional}
                                            onChange={(date, value) => {
                                                setFormState({
                                                    ...formState,
                                                    start_date_additional: value ? value : undefined
                                                })
                                            }}
                                            disabled={formState.locked || !canEdit}
                                        />
                                    </Grid>
                                    <Grid item md={4}>
                                        <WCVDatePicker
                                            {...hasError('end_date_additional')}
                                            id="end_date_additional"
                                            label="Additional Nights End:"
                                            value={formState.end_date_additional}
                                            onChange={(date, value) => {
                                                setFormState({
                                                    ...formState,
                                                    end_date_additional: value ? value : undefined
                                                })
                                            }}
                                            disabled={formState.locked || !canEdit}
                                        />
                                    </Grid>
                                    <Grid item md={4}>
                                        <TextField
                                            {...hasError('max_additional_nights')}
                                            fullWidth
                                            margin="normal"
                                            type="number"
                                            label="Max Additional Nights"
                                            name="max_additional_nights"
                                            onChange={handleFieldChange}
                                            InputLabelProps={{shrink: true}}
                                            value={formState.max_additional_nights}
                                            variant="outlined"
                                            disabled={formState.locked || !canEdit}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}

                        {isAdmin && showPrices && (
                            <Grid item xs={6}>
                                <TextField
                                    {...hasError('convenience_fee')}
                                    fullWidth
                                    type="number"
                                    label="Convenience Fee"
                                    name="convenience_fee"
                                    onChange={handleFieldChange}
                                    value={formState.convenience_fee}
                                    variant="outlined"
                                    disabled={formState.locked || !canEdit}
                                    InputProps={{
                                        startAdornment: <InputAdornment
                                            position="start">$</InputAdornment>,
                                    }}
                                />
                            </Grid>
                        )}

                        {isAdmin && showPrices && (
                            <Grid item md={3} sm={6}>
                                <TextField
                                    {...hasError('comp_dollar_value')}
                                    fullWidth
                                    type="number"
                                    label="Comp Dollar Value"
                                    name="comp_dollar_value"
                                    onChange={handleFieldChange}
                                    value={formState.comp_dollar_value}
                                    variant="outlined"
                                    disabled={formState.locked || !canEdit}
                                    InputProps={{
                                        startAdornment: <InputAdornment
                                            position="start">$</InputAdornment>,
                                    }}
                                />
                            </Grid>
                        )}

                        <Grid item md={isAdmin ? 3 : 6} sm={6}>
                            <TextField
                                {...hasError('comp_ratio')}
                                fullWidth
                                type="number"
                                label="Comp Ratio"
                                name="comp_ratio"
                                onChange={handleFieldChange}
                                value={formState.comp_ratio}
                                variant="outlined"
                                disabled={formState.locked || !canEdit || !isAdmin}
                                InputProps={{
                                    startAdornment: <InputAdornment
                                        position="start">1/</InputAdornment>,
                                }}
                            />
                        </Grid>

                        {/*{showPrices && (*/}
                        {/*    <Grid item md={isAdmin ? 3 : 6} sm={6}>*/}
                        {/*        <TextField*/}
                        {/*            fullWidth*/}
                        {/*            type="number"*/}
                        {/*            label="Comp Dollar Estimate"*/}
                        {/*            value={compDollarEstimate}*/}
                        {/*            variant="outlined"*/}
                        {/*            disabled={true}*/}
                        {/*            InputProps={{*/}
                        {/*                startAdornment: <InputAdornment position="start">$</InputAdornment>,*/}
                        {/*            }}*/}
                        {/*        />*/}
                        {/*    </Grid>*/}
                        {/*)}*/}

                        {isAdmin && showPrices && (
                            <Grid item md={3} sm={6}>
                                <TextField
                                    fullWidth
                                    type="number"
                                    label="Final Comp Value"
                                    name="comp_final_value"
                                    onChange={handleFieldChange}
                                    value={formState.comp_final_value}
                                    variant="outlined"
                                    InputProps={{
                                        startAdornment: <InputAdornment
                                            position="start">$</InputAdornment>,
                                    }}
                                />
                            </Grid>
                        )}

                        {isAdmin && showPrices && !!showCreditCardFee && (
                            <Grid item xs={3}>
                                <TextField
                                    {...hasError('credit_card_fee')}
                                    fullWidth
                                    type="number"
                                    label="Credit Card Fee"
                                    name="credit_card_fee"
                                    onChange={(event: any) => handleCCFeeChange(event)}
                                    value={formState.credit_card_fee}
                                    variant="outlined"
                                    disabled={formState.locked || !canEdit}
                                    InputProps={{
                                        startAdornment: <InputAdornment
                                            position="start">%</InputAdornment>,
                                    }}
                                />
                            </Grid>
                        )}

                        {isAdmin && (
                            <Grid item xs={12}>
                                <Grid component="label" container alignItems="center" spacing={1}>
                                    <Grid item>
                                        <Switch
                                            color="secondary"
                                            edge="start"
                                            name="credit_card_fee_enabled"
                                            onChange={() => setShowCreditCardFee(!showCreditCardFee)}
                                            checked={!!showCreditCardFee}
                                            disabled={formState.locked || !canEdit}
                                        />
                                    </Grid>
                                    <Grid item><Typography variant="h5">Credit Card
                                        Fee?</Typography></Grid>
                                </Grid>
                            </Grid>
                        )}

                        {isAdmin && (
                            <Grid item xs={12}>
                                <Grid component="label" container alignItems="center" spacing={1}>
                                    <Grid item>
                                        <Switch
                                            checked={!!formState.default_authorize_members}
                                            color="secondary"
                                            edge="start"
                                            name="default_authorize_members"
                                            onChange={handleFieldChange}
                                            disabled={formState.locked || !canEdit}
                                        />
                                    </Grid>
                                    <Grid item><Typography variant="h5">Default Authorize
                                        Members?</Typography></Grid>
                                </Grid>
                            </Grid>
                        )}

                        {isAdmin && (
                            <Grid item md={12} xs={12}>
                                <Grid component="label" container alignItems="center" spacing={1}>
                                    <Grid item>
                                        <Switch
                                            checked={!!formState.disabled}
                                            color="secondary"
                                            edge="start"
                                            name="disabled"
                                            onChange={handleFieldChange}
                                            disabled={formState.locked || !canEdit}
                                        />
                                    </Grid>
                                    <Grid item><Typography
                                        variant="h5">Disabled?</Typography></Grid>
                                </Grid>
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            {canEdit && (
                                <Button className={classes.saveButton} onClick={onSaveClick}
                                        variant="contained"
                                        disabled={!errors.isValid || formState.locked || !canEdit}>Save</Button>
                            )}

                            {isAdmin && (
                                <Can permission="groups.delete">
                                    <Button onClick={handleClickOpen}
                                            className={classes.deleteButton}
                                            variant="contained"
                                            disabled={isNewGroup}>
                                        Delete
                                    </Button>
                                </Can>
                            )}

                            {isAdmin && (
                                <Button className={classes.cloneButton} onClick={onCloneClick}
                                        variant="contained"
                                        disabled={isNewGroup || !errors.isValid}>
                                    Clone
                                </Button>
                            )}
                        </Grid>

                    </Grid>
                </CardContent>
            </Card>
        </React.Fragment>
    );
}

export const GroupDetailsBillingPartiesTab = (props: {
    group: Group,
    isAdmin: boolean,
    canEdit: boolean
}) => {
    const classes = useStyles();
    const {isAdmin, group, canEdit} = props;
    const isNewGroup = group.id === -1
    const [openBillingPartyModal, setOpenBillingPartyModal] = useState(false)
    const handleOpenBillingPartyModal = () => {
        setOpenBillingPartyModal(true)
    }
    const handleCloseBillingPartyModal = () => {
        setOpenBillingPartyModal(false)
    }
    const [billingPartyFilters, setBillingPartyFilters] = useState();
    const downloadBillingParties = () => {
        const url = getHost() + '/api/billing_parties/download';
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                group_id: group.id,
                ...billingPartyFilters
            })
        })
            .then(res => res.blob())
            .then(blob => {
                const downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(blob);
                downloadLink.download = 'billing_parties.csv';
                document.body.appendChild(downloadLink);
                downloadLink.click();
                downloadLink.remove();
            })
    }

    return (
        <React.Fragment>
            <Card className={classes.container}>
                <CardHeader title={'Group Bookings'} action={isAdmin && ([
                    <Button
                        className={classes.saveButton}
                        variant="contained"
                        onClick={handleOpenBillingPartyModal}
                    >
                        Add New Billing Party
                    </Button>,

                    <Button
                        color="primary"
                        variant="outlined"
                        onClick={downloadBillingParties}
                    >
                        Download Billing Parties
                    </Button>
                ])}

                />
                <Divider/>
                <CardContent className={classes.card}>
                    <BillingPartyListContent groupId={group.id} groupRef={group.booking_form_url}
                                             setBillingPartyFilters={setBillingPartyFilters}
                                             setSelectedBillingParty={isAdmin ? undefined : (dummy: any) => console.log('billing party click noop.')}
                                             isAdmin={isAdmin} canEdit={canEdit}/>
                </CardContent>
                {openBillingPartyModal && group.start_date && group.end_date && (
                    <NewBillingPartyModal groupId={group.id} startDate={group.start_date}
                                          endDate={group.end_date}
                                          onClose={handleCloseBillingPartyModal} open={true}/>
                )}
            </Card>
        </React.Fragment>
    )
}

export const GroupDetailsRoomPartiesTab = (props: {
    group: Group,
    isAdmin: boolean,
    canEdit: boolean
}) => {
    const classes = useStyles();
    const {isAdmin, group, canEdit} = props;
    const isNewGroup = group.id === -1;

    //Merge modal functions
    const [openMergePopup, setOpenMergePopup] = useState(false);
    const handleOpenMergePopup = () => {
        setOpenMergePopup(true);
    };
    const handleCloseMergePopup = () => {
        setOpenMergePopup(false);
    };

    return (
        <React.Fragment>
            <Card className={classes.container}>
                <CardHeader
                    title={'Group Rooms'}
                    action={[
                        isAdmin && <Button key="merge" color="primary" variant="outlined"
                                           onClick={handleOpenMergePopup}>Merge Room
                            Parties</Button>,
                    ]}
                />
                <Divider/>
                <CardContent className={classes.card}>
                    <RoomPartyListContent groupId={group.id} groupRef={group.booking_form_url}
                                          isAdmin={isAdmin}
                                          canEdit={canEdit}
                                          setSelectedRoomParty={isAdmin ? undefined : (dummy: any) => console.log('room party click noop.')}/>
                </CardContent>

                {openMergePopup && (
                    <MergeRoomPartyModal onClose={handleCloseMergePopup} open={openMergePopup}
                                         groupId={group.id}/>)}
            </Card>
        </React.Fragment>
    )
}

export const GroupDetailsMembersTab = (props: {
    group: Group,
    isAdmin: boolean,
    canEdit: boolean
}) => {
    const classes = useStyles();
    const {isAdmin, group, canEdit} = props;
    const {history} = useRouter();
    const isNewGroup = group.id === -1;

    const [formState, setFormState] = useState({...group});
    return (
        <React.Fragment>
            <Card className={classes.container}>
                <CardHeader title="Group Members" action={isAdmin && (
                    <Button
                        className={classes.saveButton}
                        variant="contained"
                        onClick={() => history.push('/groupmembers/new/' + formState.id)}
                        disabled={formState.locked || !canEdit}
                    >
                        Add Member
                    </Button>
                )}/>
                <CardContent className={classes.card}>
                    <GroupMemberListContent groupId={formState.id}
                                            groupRef={formState.booking_form_url}
                                            isAdmin={isAdmin}
                                            canEdit={canEdit}
                                            setSelectedMember={isAdmin ? undefined : (dummy: any) => console.log('group member click noop')}/>
                </CardContent>
            </Card>
        </React.Fragment>
    )
}

export const GroupDetailsAdminsTab = (props: {
    group: Group,
    isAdmin: boolean,
    canEdit: boolean
}) => {
    const classes = useStyles();
    const {isAdmin, group, canEdit} = props;
    const isNewGroup = group.id === -1;
    const {enqueueSnackbar} = useSnackbar();
    const canFullUpdate = checkPermission('groups.update');
    const [sendFullUpdateGroup, updateData] = updateGroup();
    const [sendLimitedUpdateGroup, limitedUpdateData] = limitedUpdateGroup();
    const sendUpdateGroup: any = canFullUpdate ? sendFullUpdateGroup : sendLimitedUpdateGroup;

    //1. Set form and error state
    const [formState, setFormState] = useState({...group});


    //tours
    const toursData = availableTours();
    const [errors, setErrors] = useState({
        isValid: false,
        errors: {
            name: false,
            description: false,
            start_date: false,
            end_date: false,
            admissions_cutoff: false,
        }
    });

    const selectedTour = formState && (toursData.data && toursData.data.availableTours) ? toursData.data.availableTours.find(tour => Number(tour.id) === formState.tour_resource_id) : null;

    //3. setup validation and error hook using useMemo to prevent infinite re-renders
    const validateSchema = useMemo(() => {
        const schema: any = {
            name: {
                presence: {allowEmpty: false, message: 'is required'},
            },
            description: {
                presence: {allowEmpty: false, message: 'is required'},
            },
            start_date: {
                presence: {allowEmpty: false, message: 'is required'},
            },
            end_date: {
                presence: {allowEmpty: false, message: 'is required'},
            },
            admissions_cutoff: {
                presence: {allowEmpty: false, message: 'is required'},
                datetime: {
                    latest: formState.start_date ? moment.utc(formState.start_date) : undefined,
                    message: '^Admission cutoff must be before the group start date' + (formState.start_date ? ', ' + formState.start_date : '')
                },
            },
            hotel: {
                presence: {allowEmpty: false, message: 'is required'},
            },
            tour: {
                presence: {allowEmpty: false, message: 'is required'},
            },
            description_resort: {
                presence: {allowEmpty: false, message: 'is required'},
            },
            description_whats_included: {
                presence: {allowEmpty: false, message: 'is required'},
            },
            description_checkin: {
                presence: {allowEmpty: false, message: 'is required'},
            },
        };

        if (selectedTour) {
            const calculatedStartDate = moment.utc(selectedTour.available_from).subtract(selectedTour.max_nights_before, 'days');
            const calculatedEndDate = moment.utc(selectedTour.available_to).add(selectedTour.max_nights_after, 'days');

            schema.start_date.datetime = {
                earliest: moment.utc(selectedTour.available_from),
                message: `^Start date must be on or after the tour additional night's start date, ${calculatedStartDate.format('YYYY-MM-DD')}`
            };
            schema.end_date.datetime = {
                latest: moment.utc(selectedTour.available_to),
                message: `^End date must be on or before the tour additional night's end date, ${calculatedEndDate.format('YYYY-MM-DD')}`
            };
        }

        return schema;
    }, [formState.start_date, selectedTour]);

    useEffect(() => {
        const newErrors = validate(formState, validateSchema);

        setErrors(state => ({
            ...state,
            isValid: !newErrors,
            errors: newErrors || {}
        }));
    }, [formState, validateSchema]);

    const addAdminUser = (userId: number) => {
        const sanitisedData: UpdateGroupInput = {
            data: {id: formState.id, associatedUsers: {connect: [userId]}}
        };

        sendUpdateGroup({variables: sanitisedData})
            .then(() => {
                enqueueSnackbar('Group Updated.', {variant: 'success'});
            })
            .catch(() => {
                enqueueSnackbar('Group Update Failed!', {variant: 'error'});
            });
    };

    const removeAdminUser = (userId: number) => {
        const sanitisedData: UpdateGroupInput = {
            data: {id: formState.id, associatedUsers: {disconnect: [userId]}}
        };

        sendUpdateGroup({variables: sanitisedData})
            .then(() => {
                enqueueSnackbar('Group Updated.', {variant: 'success'});
            })
            .catch(() => {
                enqueueSnackbar('Group Update Failed!', {variant: 'error'});
            });
    };

    return (
        <React.Fragment>
            <Card className={classes.container}>
                <CardHeader title="3rd Part Admins"/>
                <CardContent className={classes.card}>
                    <GroupAdminListContent group={group} rowsPerPage={5} addAdminUser={addAdminUser}
                                           removeAdminUser={removeAdminUser}/>
                </CardContent>
            </Card>
        </React.Fragment>
    )
}


export const GroupDetailsDocumentsTab = (props: {
    group: Group,
    isAdmin: boolean,
    canEdit: boolean
}) => {
    const classes = useStyles();
    const {isAdmin, group, canEdit} = props;
    const meData = getMe();
    const [selectedDocument, setSelectedDocument] = useState();

    return (
        <React.Fragment>
            <Card className={classes.container}>
                <CardHeader
                    title={'Documents'}
                    action={[
                        isAdmin &&
                        <Button key="merge"
                                color="primary"
                                variant="outlined"
                                onClick={() => {
                                    const doc = getBlankDocument(meData.data!.me!.id);
                                    doc.type = WcvType.GROUP;
                                    doc.type_id = group.id;
                                    setSelectedDocument(doc);
                                }}>
                            Add Document
                        </Button>
                    ]}
                />
                <Divider/>
                <CardContent className={classes.card}>
                    {selectedDocument && (
                        <DocumentDetailsContent document={selectedDocument}
                                                setSelectedDocument={setSelectedDocument}
                                                fileTypes=".php,application/pdf,image/*"/>
                    )}
                    {!selectedDocument && (
                        <DocumentListContent type={WcvType.GROUP}
                                             type_id={group.id}
                                             isAdmin={isAdmin}
                                             setSelectedDocument={
                                                 isAdmin ? undefined : (dummy: any) => console.log('document click noop')
                                             }/>
                    )}
                </CardContent>
            </Card>
        </React.Fragment>
    )
}

export const GroupDetailsTabs = (props: { group: Group, isAdmin: boolean, canEdit: boolean }) => {
    const classes = useStyles();
    const {isAdmin, group, canEdit} = props;
    const isNewGroup = group.id === -1;
    const [tab, setTab] = useState(isNewGroup ? 'details' : 'overview');
    const canAssociateUser = checkPermission('groups.associate_user');

    const groupForDetailsTabData = isNewGroup ? {
        loading: false,
        data: {group: getBlankGroup()},
        error: null
    } : getGroupWithQuery(Number(group.id), gqlGroupForDetailsTabQuery);
    const groupForDetailsTab = groupForDetailsTabData && !groupForDetailsTabData.loading && groupForDetailsTabData.data && groupForDetailsTabData.data.group;

    const groupForMembersTabData = isNewGroup ? {
        loading: false,
        data: {group: getBlankGroup()},
        error: null
    } : getGroupWithQuery(Number(group.id), gqlGroupForMembersTabQuery);
    const groupForMembersTab = groupForMembersTabData && !groupForMembersTabData.loading && groupForMembersTabData.data && groupForMembersTabData.data.group;

    const groupForBillingPartiesTabData = isNewGroup ? {
        loading: false,
        data: {group: getBlankGroup()},
        error: null
    } : getGroupWithQuery(Number(group.id), gqlGroupForBillingPartiesTabQuery);
    const groupForBillingPartiesTab = groupForBillingPartiesTabData && !groupForBillingPartiesTabData.loading && groupForBillingPartiesTabData.data && groupForBillingPartiesTabData.data.group;

    const groupForRoomPartiesTabData = isNewGroup ? {
        loading: false,
        data: {group: getBlankGroup()},
        error: null
    } : getGroupWithQuery(Number(group.id), gqlGroupForRoomPartiesTabQuery);
    const groupForRoomPartiesTab = groupForRoomPartiesTabData && !groupForRoomPartiesTabData.loading && groupForRoomPartiesTabData.data && groupForRoomPartiesTabData.data.group;

    const groupForAdminsTabData = isNewGroup ? {
        loading: false,
        data: {group: getBlankGroup()},
        error: null
    } : getGroupWithQuery(Number(group.id), gqlGroupForAdminsTabQuery);
    const groupForAdminsTab = groupForAdminsTabData && !groupForAdminsTabData.loading && groupForAdminsTabData.data && groupForAdminsTabData.data.group;

    const groupOptionsData = isNewGroup ? {
        loading: false,
        data: {group: getBlankGroup()},
        error: null
    } : getGroupWithQuery(Number(group.id), gqlGroupOptionsQuery);
    const groupOptions = groupOptionsData && !groupOptionsData.loading && groupOptionsData.data && groupOptionsData.data.group;

    return (
        <React.Fragment>
            <Tabs className={classes.tabs} onChange={(event, value) => setTab(value)}
                  scrollButtons="auto" value={tab}
                  variant="scrollable">
                {!isNewGroup && <Tab label="Overview" value="overview"/>}
                <Tab label="Details" value="details"/>
                {!isNewGroup && <Tab label="Billing Parties" value="billing_parties"/>}
                {!isNewGroup && <Tab label="Room Parties" value="room_parties"/>}
                {!isNewGroup && <Tab label="Members" value="members"/>}
                {!isNewGroup && <Tab label="Pending Approval" value="pending_approval"/>}
                {isAdmin && !isNewGroup && <Tab label="Admins" value="admins"/>}
                {isAdmin && !isNewGroup && <Tab label="Options" value="options"/>}
                {!isNewGroup && <Tab label="Documents" value="documents"/>}
                {!isNewGroup && <Tab label="Overdue Documents" value="overdue_documents"/>}
                {isAdmin && !isNewGroup && <Tab label="Logs" value="logs"/>}
            </Tabs>

            {!isNewGroup && tab === 'overview' && (
                <GroupDetailsOverviewTab group={group} isAdmin={isAdmin} canEdit={canEdit}/>
            )}

            {tab === 'details' && groupForDetailsTabData.loading && (
                <React.Fragment>
                    <CardHeader title={'Group Details'}
                                className={classes.buttonWrapper}
                                classes={{action: classes.buttonHeader}}/>
                    <Divider/>
                    <CardContent className={classes.card}>
                        <Grid item xs={4}>
                            <Typography><T phrase="Loading..."/></Typography>
                        </Grid>
                    </CardContent>
                </React.Fragment>
            )}

            {tab === 'details' && groupForDetailsTab && !groupForDetailsTabData.loading && (
                <GroupDetailsDetailTab group={groupForDetailsTab} isAdmin={isAdmin}
                                       canEdit={canEdit}/>
            )}

            {!isNewGroup && tab === 'billing_parties' && groupForBillingPartiesTabData.loading && (
                <React.Fragment>
                    <CardHeader title={'Group Bookings'}/>
                    <Divider/>
                    <CardContent className={classes.card}>
                        <Grid item xs={4}>
                            <Typography><T phrase="Loading..."/></Typography>
                        </Grid>
                    </CardContent>
                </React.Fragment>
            )}

            {!isNewGroup && tab === 'billing_parties' && groupForBillingPartiesTab && !groupForBillingPartiesTabData.loading && (
                <GroupDetailsBillingPartiesTab group={groupForBillingPartiesTab} isAdmin={isAdmin}
                                               canEdit={canEdit}/>
            )}

            {!isNewGroup && tab === 'room_parties' && groupForRoomPartiesTabData.loading && (
                <React.Fragment>
                    <CardHeader title={'Group Rooms'}/>
                    <Divider/>
                    <CardContent className={classes.card}>
                        <Grid item xs={4}>
                            <Typography><T phrase="Loading..."/></Typography>
                        </Grid>
                    </CardContent>
                </React.Fragment>
            )}

            {!isNewGroup && tab === 'room_parties' && groupForRoomPartiesTab && !groupForRoomPartiesTabData.loading && (
                <GroupDetailsRoomPartiesTab group={groupForRoomPartiesTab} isAdmin={isAdmin}
                                            canEdit={canEdit}/>
            )}

            {!isNewGroup && tab === 'members' && groupForMembersTabData.loading && (
                <React.Fragment>
                    <CardHeader title="Group Members"/>
                    <Divider/>
                    <CardContent className={classes.card}>
                        <Grid item xs={4}>
                            <Typography><T phrase="Loading..."/></Typography>
                        </Grid>
                    </CardContent>
                </React.Fragment>
            )}

            {!isNewGroup && tab === 'members' && groupForMembersTab && !groupForMembersTabData.loading && (
                <GroupDetailsMembersTab group={groupForMembersTab} isAdmin={isAdmin}
                                        canEdit={canEdit}/>
            )}

            {!isNewGroup && tab === 'pending_approval' && (
                <GroupMembersPendingApprovalListContent groupId={group.id}
                                                        groupRef={group.booking_form_url}
                                                        isAdmin={isAdmin} canEdit={canEdit}/>
            )}

            {!isNewGroup && tab === 'admins' && canAssociateUser && groupForAdminsTabData.loading && (
                <React.Fragment>
                    <CardHeader title="3rd Part Admins"/>
                    <Divider/>
                    <CardContent className={classes.card}>
                        <Grid item xs={4}>
                            <Typography><T phrase="Loading..."/></Typography>
                        </Grid>
                    </CardContent>
                </React.Fragment>
            )}

            {!isNewGroup && tab === 'admins' && canAssociateUser && groupForAdminsTab && !groupForAdminsTabData.loading && (
                <GroupDetailsAdminsTab group={groupForAdminsTab} isAdmin={isAdmin}
                                       canEdit={canEdit}/>
            )}

            {!isNewGroup && tab === 'options' && groupOptionsData.loading && (
                <React.Fragment>
                    <CardHeader title="Selected Options"/>
                    <Divider/>
                    <CardContent className={classes.card}>
                        <Grid item xs={4}>
                            <Typography><T phrase="Loading..."/></Typography>
                        </Grid>
                    </CardContent>
                </React.Fragment>
            )}

            {!isNewGroup && tab === 'options' && groupOptions && !groupOptionsData.loading && (
                <GroupOptions group={groupOptions} isAdmin={isAdmin} canEdit={canEdit}/>
            )}

            {!isNewGroup && tab === 'documents' && (
                <GroupDetailsDocumentsTab group={group} isAdmin={isAdmin} canEdit={canEdit}/>
            )}

            {!isNewGroup && tab === 'overdue_documents' && (
                <OverdueDocumentListLoad groupId={group.id}/>
            )}

            {!isNewGroup && tab === 'logs' && (
                <LogListContent type={WcvType.GROUP} type_id={group.id}/>
            )}
        </React.Fragment>

    );
}

export default GroupDetailsTabs;
